import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { SpinnerCircular } from "spinners-react";
import { useAuth } from "../Components/hooks/UseAuth";
import { getToken } from "../services/security";
import classes from "./PrivateRoute.module.scss";

const PrivateRoute = () => {
  const { setAuthenticated, validate } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      const result = await validate();
      setIsAuthenticated(result);
      setIsLoading(false);
      setAuthenticated(result);
    };
    checkAuth();
  }, [validate, setAuthenticated]);

  if (isLoading) {
    return (
      <div className={classes.Loading}>
        <SpinnerCircular
          size="60px"
          thickness={150}
          color="#1597d4"
          secondaryColor="#eeedfd"
        />
      </div>
    );
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;